var styles = {"article":"SkipNavigation-module_article__e-Te9","link":"SkipNavigation-module_link__vqXAe"};

export { styles as default };
